import { StyleRules, DividerClassKey } from '@material-ui/core';
import colors from 'styles/colors.module.scss';

export const MuiDivider: Partial<StyleRules<DividerClassKey, {}>> = {
  root: {
    height: 2,
    backgroundColor: colors.primary300,
  },
};
